export default __webpack_public_path__ + "static/media/30minutes.f2796baf.png";